import React from "react";
import { motion } from "framer-motion";
// import { CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";

export default function ThankYou() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-white px-4">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="bg-white shadow-xl rounded-2xl p-8 md:p-12 max-w-lg w-full text-center space-y-5"
      >
        <div className="flex justify-center">
          {/* <CheckCircle className="text-green-600" size={70} /> */}
          <img src="https://mhcockpit.com/Media/Colleges/Vels%20Landing/Converted/vels-logo.webp" alt="Vels University Logo" />
        </div>
        <div className="flex justify-center items-start gap-3">
          <p className="text-lg font-semibold text-[#000074]">Knowledge Partner</p>
          <img
            src="https://mhcockpit.com/Media/Logo/mh-cockpit-logo-black-and-grey.webp"
            alt="MH Cockpit Logo"
            className="w-32"
          />
        </div>

        <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
          Thank You!
        </h1>

        <p className="text-gray-600 text-sm md:text-base leading-relaxed">
          Your form has been submitted successfully.
          Our team from <strong>MH Cockpit</strong> will contact you shortly.
        </p>

        <div className="flex max-sm:flex-col justify-between max-sm:gap-5">
          <Link
            to="/"
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-8 rounded-lg shadow-md transition"
          >
            Go Back Home
          </Link>
          <a
            className="bg-gradient-to-b hover:bg-gradient-to-t from-[#fc8d06] to-[#ff4d00] text-white text-xl font-semibold p-3 rounded-lg"
            href="/files/Vels Aviation 2026.pdf"
            download="Vels Aviation 2026.pdf"
          >
            Download Brochure
          </a>
        </div>
      </motion.div>
    </div>
  );
}
